export default __webpack_public_path__ + "static/media/synthetics.ad04cb78.svg";